import { render } from "./itemRevoke.vue?vue&type=template&id=1e98217a&scoped=true"
import script from "./itemRevoke.vue?vue&type=script&lang=js"
export * from "./itemRevoke.vue?vue&type=script&lang=js"

import "./itemRevoke.vue?vue&type=style&index=0&id=1e98217a&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e98217a"]])

export default __exports__